import React from 'react';
import { Menu, Tooltip } from 'antd';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { actions } from '~/stores/ducks';
import { CustomerService, MenuService, UserService } from '~/services';
import AtualizarCadastroView from '~/pages/general/AtualizarCadastroView.jsx';
import './BaseMenu.less';

const menu = require('./menu.json');
const menuBenassi = require('./menu_benassi.json');
const menuPosto = require('./menu_posto.json');

class BaseMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showAtualizarCadastro: false,
    };
  }

  getPopupContainer = () => {
    const { settings } = this.props;

    if (settings.fixedHeader && settings.layout === 'topmenu') {
      return this.wrap;
    }

    return document.body;
  };

  onClick = ({ key }) => {
    const { general, setGeneral, resetTabs } = this.props;

    resetTabs();

    MenuService.open(MenuService.getById(key));

    if (general.isMobile) {
      setGeneral({ ...general, isCollapsed: true });
    }
  };

  renderSubMenuOrItem = item => {
    const { tabs } = this.props;

    if (item.submenus) {
      return (
        <Menu.SubMenu key={item.idt} title={item.nome}>
          {item.submenus.map(submenu => this.renderSubMenuOrItem(submenu))}
        </Menu.SubMenu>
      );
    }

    return (
      <>
        <Menu.Item key={item.idt} className={tabs.data.length > 0 && item.idt === tabs.data[0].menuId ? 'box-selected' : 'box-idle'}>
          <div className="triangulo-up" />
          <div className="white-box">
            <div className={`icon ${item.chave}`} />
            <div>{item.nome}</div>
          </div>
          <div className="triangulo-down" />
        </Menu.Item>
      </>
    );
  };

  render() {
    const { showAtualizarCadastro } = this.state;
    const { className, style, mode, settings } = this.props;
    const isPosto = CustomerService.getCustomer().posto;
    const isFLV = CustomerService.getCustomer().sistema === 'BENASSI';
    const menuSistema = isFLV ? menuBenassi : isPosto ? menuPosto : menu;

    return (
      <>
        <AtualizarCadastroView action={showAtualizarCadastro} onOk={() => this.setState({ showAtualizarCadastro: false })} showCancel />

        <Tooltip title={UserService.getUser().trocar_senha_portal === 'S' ? 'Altere sua senha' : undefined} color="red">
          <div className="box-submenu">
            <Menu
              className={classNames(className, 'idle', UserService.getUser().trocar_senha_portal === 'S' ? 'div-disabled' : '')}
              style={style}
              mode={mode}
              subMenuCloseDelay={0.5}
              subMenuOpenDelay={0.3}
              theme={settings.theme}
              getPopupContainer={this.getPopupContainer}
              selectedKeys={[]}
              onClick={this.onClick}
            >
              {menuSistema && menuSistema.filter(ifilter => ifilter.chave !== 'AlterarSenhaPage').map(item => this.renderSubMenuOrItem(item))}
            </Menu>
          </div>
          <div ref={ref => (this.wrap = ref)} />
        </Tooltip>
      </>
    );
  }
}

const mapStateToProps = ({ settings, general, tabs }) => ({ settings, general, tabs });
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BaseMenu);
